import { Component, ChangeDetectorRef, inject } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ContactResponse } from '../../../admin/interfaces/find-email.interface';
import { UserAccountFeature } from '../../../enums/user-account-feature.enum';

@Component({
    standalone: false,
    selector: 'por-role-checkbox-renderer',
    templateUrl: './role-checkbox.html'
})
export class RoleCheckboxRendererComponent implements ICellRendererAngularComp {
    private readonly cdr = inject(ChangeDetectorRef);

    public params!: ICellRendererParams;
    checked = false;
    roleKey!: UserAccountFeature;
    isHide = false;

    public contact!: ContactResponse;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.roleKey = params.colDef?.cellRendererParams?.roleKey;
        this.contact = { ...params.data };

        const roles = this.contact.roles ?? {};
        this.checked = !!roles[this.roleKey];
        this.computeDisableState(roles);
    }

    onCheckboxChange(isChecked: boolean): void {
        if (this.params.context && this.params.context.componentParent) {
            this.params.context.componentParent.onCheckboxChange({
                email: this.contact.email,
                customerId: this.contact.customerId,
                enabled: isChecked,
                role: this.roleKey
            });
        }
    }

    computeDisableState(roles: Record<string, boolean>): void {
        const isOperatorSelected = roles[UserAccountFeature.Operator];
        const isPMorFinanceSelected = roles[UserAccountFeature.ProjectManager] || roles[UserAccountFeature.Finance];

        const shouldHide =
            (this.roleKey === UserAccountFeature.Operator && isPMorFinanceSelected) ||
            ([UserAccountFeature.ProjectManager, UserAccountFeature.Finance, UserAccountFeature.Admin].includes(this.roleKey) && isOperatorSelected);

        if (shouldHide) {
            this.isHide = true;

            if (this.checked) {
                this.checked = false;
                // Notify parent about the auto-uncheck
                // this.onCheckboxChange(false);
            }
        } else {
            this.isHide = false;
        }
        this.cdr.detectChanges();
    }

    refresh(): boolean {
        return false;
    }
}
